<template>
	<sf-data-table
		ref="grpTable"
		index
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
		
	>
		
		<template v-slot:customRows="slotProps">
			<!-- <el-table-column v-if="slotProps.column.property==='totCnt'" >
				<el-table-column v-if="slotProps.column.property==='totCnt'" >
					
				</el-table-column>
			</el-table-column> -->
			<template v-for="(item, index) in monthlabel">
				
				<template v-if="slotProps.column.property === item">
					<td
						:key="index"
						class="col-1"
						style="all: unset; cursor: pointer; text-align: right"
						@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
					>
						{{ slotProps.row[slotProps.column.property] }}
					</td>
				</template>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@mqy/clma/PcClmPrs/store/helpers';
import PcRoList from '@mqy/clma/PcRoList/PcRoList.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			monthlabel: '',
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {
		
		this.monthlabel = this.monthlabel_;
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.grdList;
		},
		cols() {
			return this.dayCols_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		async onGoClick(argsCnt, rowsInfo) {
			return false;
			//값이 없을땐 이동을 못함.
			if (argsCnt == 0 || argsCnt == '') {
				return false;
			}

			return false;

			let item = {
				name: this.getMessage_('QWCC001590'), //PMC 판매정보
				component: PcRoList, //import할 컴포넌트 이름
				scrId: this.pcRoListScrId, //이동할 scr
				msgKey: 'QWCC001590' //R/O리스트
			};
			//console.log('item ::', item);

			const {
				srchMm01 = '',
				carScn = '',
				pacScn = '',
				flclSpc = '',
				ctype = '',
				idxScn = '',
				useTerm = '',
				carTypeNm = '',
				check = '',
				occuRegn = '',
				strtMm01 = '',
				endMm01 = ''
			} = this.searchParams; //검색값

			const label = rowsInfo.column.labelClassName;
			const phmnCd = rowsInfo.row.phmnCd;
			const partNo = rowsInfo.row.partNo;
			const labelDt = this.$moment(label).format('YYYYMMDD');

			const pStartDt = this.$moment(strtMm01).format('YYYYMMDD'); //oem판매 종료월
			const pEndDt = this.$moment(endMm01).format('YYYYMMDD'); //oem판매 시작월
			const pStartDt2 = labelDt; //확정 종료월
			const pEndDt2 = labelDt; //확정 시작월
			const pState2 = carScn; // 차량구분
			const pState3 = pacScn; // 승상구분
			const pState4 = flclSpc; // 연료전지사양
			const pState5 = occuRegn; // 판매지역
			const pState9 = ctype; // ctype
			const pState10 = srchMm01; // 판매월
			const pState11 = '20'; // 조건월(20; 확정월)
			const pState12 = useTerm; // 사용기간(년)
			const pState13 = idxScn; // 지수구분
			const pState14 = phmnCd; // 현상코드
			const pState15 = check; // 누적
			const pState16 = partNo; // 원인부품번호
			const pState17 = carTypeNm; //차종유형
			//console.log('pState14', pState14);

			await this.getScreen_({ scrId: item.scrId });
			await this.$sf_removeTab(item.scrId);
			await this.$sf_addTab(item, item.scrId, {
				scrId: item.scrId,
				pStartDt,
				pEndDt,
				pStartDt2,
				pEndDt2,
				pState2,
				pState3,
				pState4,
				pState5,
				pState9,
				pState10,
				pState11,
				pState12,
				pState13,
				pState14,
				pState15,
				pState16,
				pState17
			});
		},
		// spanMethod({ row, column, rowIndex, columnIndex }) {
		// 	if (rowIndex === 0) {
		// 		if(columnIndex === 0){
		// 			return{
		// 				rowspan: 1,
		// 				colspan: 5
		// 			}
		// 		}else if (columnIndex < 5) {
		// 			return {
		// 				rowspan: 0,
		// 				colspan: 0
		// 			};
		// 		} else {
		// 			return {
		// 				rowspan: 1,
		// 				colspan: 1
		// 			};
		// 		}
		// 	}
		// },
		
		getSummaries(param) {
        //param 是固定的对象，里面包含 columns与 data参数的对象 {columns: Array[4], data: Array[5]},包含了表格的全部的列与数据信息
        const { columns, data } = param;

        const sums = [];
		// console.log(this.rows);
		const saleNum = this.saleNumList[0] || [];
		// console.log(saleNum);
		
		
        columns.forEach((column, index) => {
		  
          if (index === 0) {
            sums[index] = this.getMessage_('QWCC001425');
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          //验证每一个value值是不是数字，若是是执行if
          if (!values.every(value => isNaN(value))) {
            
            sums[index] = saleNum[column.property];
          } else {
            sums[index] = '';
          }
        });
		//console.log(sums);
        return sums;
      },
		


	  
		

	}
};
</script>

<style>

   /* .el-table__body-wrapper {
	 margin-top: 46px;
  }
  .el-table__footer-wrapper {
    position: absolute;
    top: 48px;
    left: 0;
}
  .el-table__fixed-body-wrapper {
	margin-top: 46px;
}
.el-table__fixed-footer-wrapper {
	position: absolute;
    top: 48px;
    left: 0;
	
} */


</style>
